import {
  SET_DRIVE_METRICS,
  SET_DRIVE_DATA,
  SET_DRIVE_ROLES_METRICS,
  SET_ROLE_METRICS,
  SET_INTERVIEWR_LIST,
  SET_DRIVE_INTERVIEWR_LIST,
  SET_DEGREE_LIST,
  SET_COLLEGE_LIST,
  SET_CANDIDATE_INTERVIEW_DETAILS,
  SET_GROUP_LIST,
  SET_GROUP_CANDIDATE__LIST,
  SET_CITY_LIST,
  SET_CANDIDATE_DOCUMENTS_METRICES,
  SET_NEW_DRIVE_FRESHERS_LIST,
  SET_NEW_STATUS,
  SET_NEW_SCORE,
  SET_NEW_DRIVE_METRICS,
  SET_ROUND_DATA,
  UPDATE_ROUND_DATA,
  SET_STATUS_LIST
} from 'modules/Drives/actions'
import {
  SET_ROLES_ROUNDS,
  SET_REQUEST_DOCUMENTATION,
  SET_INTERVIEWR_LOCATION,
  SET_CANDIDATE_DOCUMENTS_LIST,
  SET_APPLICANT_METRICS,
} from 'modules/Exp-Candidates/actions'
const initialState = {
  drivesMetrics: {},
  driveRolesMetrics: [],
  roleMetrics: [],
  applicantMetrics: [],
  driveData: {},
  interViewerList: [],
  driveInterViewerList: [],
  degreeList: [],
  collegeList: [],
  candidateInterviewDetails: {},
  groupList: {},
  groupCandidateList: [],
  cityList: [],
  roleRoundList: [],
  requestDocumentList: [],
  interViewdata: [],
  canditateDocumentList: [],
  candidateDocumentsMetrices: [],
  setNewDriveFreshersList: {},
  setNewDriveStatus: [],
  setNewDriveScore: [],
  updatedStatus: {},
  statusList: [],
  
}
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_DRIVE_FRESHERS_LIST:
      return {
        ...state,
        setNewDriveFreshersList: action.data,
      }
    case SET_NEW_DRIVE_METRICS:
      return {
        ...state,
        updatedStatus: action.data,
      }

    case SET_NEW_STATUS:
      return {
        ...state,
        setNewDriveStatus: action.data,
      }
    case SET_NEW_SCORE:
      return {
        ...state,
        setNewDriveScore: action.data,
      }
    case SET_DRIVE_METRICS:
      return {
        ...state,
        drivesMetrics: action.data,
      }
    case SET_DRIVE_ROLES_METRICS:
      return {
        ...state,
        driveRolesMetrics: action.data,
      }
    case SET_APPLICANT_METRICS:
      return {
        ...state,
        applicantMetrics: action.data,
      }
    case SET_ROLE_METRICS:
      return {
        ...state,
        roleMetrics: action.data,
      }
    case SET_DRIVE_DATA:
      return {
        ...state,
        driveData: action.data,
      }
    case SET_INTERVIEWR_LIST:
      return {
        ...state,
        interViewerList: action.data,
      }
    case SET_DRIVE_INTERVIEWR_LIST:
      return {
        ...state,
        driveInterViewerList: action.data,
      }
    case SET_DEGREE_LIST:
      return {
        ...state,
        degreeList: action.data,
      }
    case SET_COLLEGE_LIST:
      return {
        ...state,
        collegeList: action.data,
      }
    case SET_CANDIDATE_INTERVIEW_DETAILS:
      return {
        ...state,
        candidateInterviewDetails: action.data,
      }
    case SET_GROUP_LIST:
      return {
        ...state,
        groupList: action.data,
      }
    case SET_GROUP_CANDIDATE__LIST:
      return {
        ...state,
        groupCandidateList: action.data,
      }
    case SET_CITY_LIST:
      return {
        ...state,
        cityList: action.data,
      }
    case SET_ROLES_ROUNDS:
      return {
        ...state,
        roleRoundList: action.data,
      }
    case SET_REQUEST_DOCUMENTATION:
      return {
        ...state,
        requestDocumentList: action.data,
      }
    case SET_INTERVIEWR_LOCATION:
      return {
        ...state,
        interViewdata: action.data,
      }
    case SET_CANDIDATE_DOCUMENTS_LIST:
      return {
        ...state,
        canditateDocumentList: action.data,
      }
    case SET_CANDIDATE_DOCUMENTS_METRICES:
      return {
        ...state,
        candidateDocumentsMetrices: action.data,
      }
      case SET_ROUND_DATA:
      return {
        ...state,
        roundData: action.data,
      }
      case UPDATE_ROUND_DATA:
      return {
        ...state,
        updateRoundData: action.data,
      }
      case SET_STATUS_LIST:
      return {
        ...state,
        statusList: action.data,
      }
     
    default:
      return state
  }
}
